import React from 'react';
import NotifyContainer from '../../containers/notify';
import HeaderContainer from '../../containers/header';
import FooterContainer from '../../containers/footer';

const NotifyPage = () => {
  return (
    <>
      <HeaderContainer />
      <NotifyContainer />
      <FooterContainer />
    </>
  );
};

export default NotifyPage;
